import { CasinoGameCard } from '@/components/casino/lobby/game-card/CasinoGameCard'
import { OriginalGameCard } from '@/components/original/OriginalGameCard'
import type { SearchResult } from '@/types/search'

interface SearchResultsProps {
	items: SearchResult[]
}

export function SearchResults({ items }: SearchResultsProps) {
	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center gap-3'>
				<span className='h-2.5 w-2.5 shrink-0 rounded-full bg-muted-foreground' aria-hidden />
				<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Search result</h2>
			</div>

			<div className='flex flex-wrap gap-6 px-[5px] pb-2 pt-1'>
				{items.map((item) =>
					item.kind === 'casino' ? <CasinoGameCard key={`casino-${item.id}`} game={item.game} /> : <OriginalGameCard key={`original-${item.id}`} game={item.game} />,
				)}
			</div>
		</section>
	)
}
